import { render } from "./Family.vue?vue&type=template&id=542f4fa6&scoped=true"
import script from "./Family.vue?vue&type=script&lang=js"
export * from "./Family.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-542f4fa6"

export default script